import * as L from 'leaflet';
const base = '/sh/freeride/';
const postSettings = {
  contentType: 'application/json',
  method: "post",
  headers: {
    'Content-Type': 'application/json',
  },
};

function newPoi(gjl) {
  return fetch(`${base}newPoi`, {
    body: JSON.stringify({ pt: gjl }),
    ...postSettings,
  }).then((data) => data.json());
}

function newPolyline(gjl) {
  return fetch(`${base}newLine`, {
    body: JSON.stringify({ line: gjl }),
    ...postSettings,
  }).then((data) => data.json());
}
function newPolygon(gjl) {
  return fetch(`${base}newPoly`, {
    body: JSON.stringify({ poly: gjl }),
    ...postSettings,
  }).then((data) => data.json());
}

const addGeoJSONLine = function(geojson) {
  return newPolyline(geojson);
}

const newFeature = function (e, ftName, type) {
  console.log('newf: ', e, ftName, type);
  const l = e.layer;
  l.properties = l.properties || {};
  l.properties.layertype = e.layerType
  var gjl = l.toGeoJSON();
  gjl.properties.name = ftName;
  gjl.properties.type = type;
  gjl.properties.active = true;
  if (e.layerType === 'marker') {
    return newPoi(gjl);
  } else if (e.layerType === 'polyline') {
    return newPolyline(gjl);
  } else if (e.layerType === 'polygon') {
    return newPolygon(gjl);
  }
};

const editFeature = function (e) {
  console.log(e);
  const res = [];
  e.layers.eachLayer(async function (layer) {
    var gjl = layer.toGeoJSON();
    gjl.properties = layer.properties;
    gjl._id = layer._id;
    console.log('GEOJ: ', gjl);
    if (layer instanceof L.Marker) {
      console.log('M LAYER: ', layer);
      const ret = await fetch(`${base}updatePoi`, {
        body: JSON.stringify({ pt: gjl }),
        ...postSettings,
      });
      res.push(ret);
    } else if (layer instanceof L.Polygon) {
      console.log('P LAYER: ', layer);
      const ret = await fetch(`${base}updatePoly`, {
        body: JSON.stringify({ poly: gjl }),
        ...postSettings,
      });
      res.push(ret);
    } else if (layer instanceof L.Polyline) {
      console.log('L LAYER: ', layer);
      const ret = await fetch(`${base}updateLine`, {
        body: JSON.stringify({ line: gjl }),
        ...postSettings,
      });
      res.push(ret);
    }
  });
  return res;
}

const deleteFeature = function (e) {
  const res = [];
  e.layers.eachLayer(async function (layer) {
    if (layer._id) {
      if (layer instanceof L.Marker) {
        const ret = await fetch(`${base}removePoi/${layer._id}`, { method: "delete" });
        res.push(ret);
      } else if (layer instanceof L.Polygon) {
        const ret = await fetch(`${base}removePoly/${layer._id}`, { method: "delete" });
        res.push(ret);
      } else if (layer instanceof L.Polyline) {
        const ret = await fetch(`${base}removeLine/${layer._id}`, { method: "delete" });
        res.push(ret);
      }
    }
  });
  return res;
}

export { newFeature, editFeature, deleteFeature, addGeoJSONLine }
